import { g as d } from "./_baseGetTag-D86WGQCZ.js";
import { r as h } from "./isSymbol-CMDcKCTp.js";
import { r as E } from "./_baseIteratee-CFWRO-WB.js";
var s, b;
function B() {
  if (b) return s;
  b = 1;
  var t = h();
  function a(e, u, i) {
    for (var n = -1, q = e.length; ++n < q; ) {
      var f = e[n], r = u(f);
      if (r != null && (x === void 0 ? r === r && !t(r) : i(r, x)))
        var x = r, _ = f;
    }
    return _;
  }
  return s = a, s;
}
var m, v;
function g() {
  if (v) return m;
  v = 1;
  function t(a, e) {
    return a > e;
  }
  return m = t, m;
}
var o, l;
function p() {
  if (l) return o;
  l = 1;
  var t = B(), a = g(), e = E();
  function u(i, n) {
    return i && i.length ? t(i, e(n, 2), a) : void 0;
  }
  return o = u, o;
}
var y = p();
const M = /* @__PURE__ */ d(y);
export {
  M as m
};
